import './seamless-scroll-polyfill'
import './HiyaJSBridge'
import 'core-js/stable'
import 'antd-mobile/es/global'
import { loadableReady } from '@loadable/component'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import { createBrowserHistory } from 'history'
import App from 'hiya-common/src/App/index'
import { http } from 'hiya-common/src/utils/axios'
import React from 'react'
import { hydrate } from 'react-dom'
import { Provider } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import { matchPath, Router } from 'react-router-dom'
import { StoreType } from '../stores/index'
import { isZY } from '../utils'
import { InitWebAnimationsJsPolyfill } from './web-animations-js'
import PendingNavDataLoader from './PendingNavDataLoader'
// import '../utils/inobounce'
// import 'inobounce'
import './index.scss'

const history = createBrowserHistory()
export { history }

export const init = ({ createStore, getRoutes, projectConfig }) => {
  const AppWithSentry = Sentry.withProfiler(App, {
    name: projectConfig.project,
  })

  const store: StoreType = createStore(window.APP_INITIAL_STATE)
  window.store = store
  window.APP_INITIAL_STATE = null
  http.setPublicFunction({
    log: console,
  })
  const routes = getRoutes(store)
  if (ENV !== 'development') {
    Sentry.init({
      dsn: XC_SENTRY_CLIENT, // webpack打包时暴露的全局变量，在src/.xcsentryrc文件中定义
      environment: ENV,
      integrations: [
        new BrowserTracing({
          // https://docs.sentry.io/platforms/javascript/guides/react/performance/instrumentation/automatic-instrumentation/
          tracingOrigins: projectConfig.tracingOrigins, // 不包含stat.izuiyou.com，避免给埋点请求添加sentry请求头导致埋点请求失败
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(
            history,
            routes,
            matchPath
          ),
        }),
      ],
      ignoreErrors: [
        'Non-Error promise rejection captured with keys: message',
        "Can't find variable: HiyaJSBridge",
        'Non-Error promise rejection captured with keys: message, name, stack',
        'ResizeObserver loop limit exceeded',
        'Bad control character in string literal in JSON at position 248',
        'Bad control character in string literal in JSON at position',
        'HiyaJSBridge is not defined',
        "Invalid character '\u0301'",
        'Non-Error promise rejection captured with value:',
      ],
      sampleRate: 0.05,
      tracesSampleRate: 0.05,
    })
    try {
      const data = store.getState().env
      Sentry.setUser({
        ...data,
        id: String(data.deviceinfo.h_m),
        ip_address: '{{auto}}',
      })
    } catch (error) {
      //
    }
  }

  const application = (
    <Provider store={store}>
      <Router history={history}>
        <PendingNavDataLoader store={store} routes={routes}>
          {() => <AppWithSentry>{renderRoutes(routes)}</AppWithSentry>}
        </PendingNavDataLoader>
      </Router>
    </Provider>
  )

  Promise.all([
    InitWebAnimationsJsPolyfill,
    new Promise((res) => {
      // ios 4.16.0 未给userAgent 写入 inapp
      if (isZY() || store.getState().env.deviceinfo?.h_av === '4.16.0') {
        if (window.HiyaJSBridge) {
          res(null)
        } else {
          document.addEventListener('HiyaJSBridgeReady', () => {
            res(null)
          })
        }
      } else {
        const nop = () => {
          // 防止端外报错
        }
        window.HiyaJSBridge = {
          registerHandler: nop,
          callHandler: nop,
          unregisterHandler: nop,
        }
        res(null)
      }
    }),
    new Promise((res) => {
      loadableReady(() => {
        res(null)
      })
    }),
  ]).then(() => {
    const root = document.getElementById('app')
    hydrate(application, root)
  })
}
